import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { TuiError, TuiAppearance } from '@taiga-ui/core';
import { TuiEditor, TuiEditorSocket } from '@taiga-ui/editor';
import { TranslateModule } from '@ngx-translate/core';

import { EditorFieldComponent } from './editor-field/editor-field.component';
import { EditorViewComponent } from './editor-view/editor-view.component';

@NgModule({
  declarations: [EditorFieldComponent, EditorViewComponent],
  imports: [CommonModule, FormsModule, TuiEditor, TuiEditorSocket, TuiError, TranslateModule, TuiAppearance],
  exports: [EditorFieldComponent, EditorViewComponent],
})
export class EditorModule {}
